import { Component } from "@angular/core";
import { PurchaseHistoryService } from "../purchaseHistory/purchaseHistory.service";
import { ActivatedRoute, Params } from "@angular/router";
import "rxjs/add/operator/switchMap";

@Component({
	selector: "purchaserPrint",
	templateUrl: "/app/purchaserPrint/purchaserPrint.template.html",
	providers: [PurchaseHistoryService]
})
export class PurchasePrintComponent {

	approvalPrint = {} as IAppovalModel;
	hasActualCost = false;

	constructor(private purchaseHistoryService: PurchaseHistoryService, private activatedRoute: ActivatedRoute) { }

	ngOnInit() {
		//the +params converts this to a number. It is weird how this works with routerLink params but you need to use switchMap because of Observables.
		this.activatedRoute.params.switchMap((params: Params) => this.purchaseHistoryService.getPurchaseById(+params["approvalId"])).subscribe((result: IPurchaseHistoryModel) => {
			if(result) {
				this.approvalPrint = result;

				this.hasActualCost = this.approvalPrint.items.some((item) => {
					return item.actualCost && item.actualCost > 0;
				});

				setTimeout(() => {
					window.print();
				}, 2000);
			}
		});
	}
}